import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark2Medium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCheckmark2Medium"><Path d="M20.7646 6.89844L9.26074 19.8115L3.23242 13.8906L4.98438 12.1074L9.13965 16.1885L18.8984 5.23535L20.7646 6.89844Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCheckmark2Medium;
